var TYPE_UNDEF = 'undefined',
WITH_CREDS = 'withCredentials',
SET_REQ_HEADER = 'setRequestHeader',
RESP_TYPE = 'responseType',
LOAD_EVT = 'onreadystatechange',
TIMEOUT_EVT = 'ontimeout',
ERR_EVT = 'onerror',
PROGRESS_EVT = 'onprogress',
MAX_TIMEOUT = 60000,

fitt = require('fitt'),
_get = require('lodash/get'),
cstr = fitt.cstr,
cnum = fitt.cnum,
struc = fitt.struc,
strlc = fitt.strlc,
mix = fitt.mix,
forEach = fitt.forEach,

FittURL = require('fitt-url'),
FittParamHash = require('fitt-paramhash'),

FittHTTPCoreUtils = require('../core/utils.js'),
createErr = FittHTTPCoreUtils.createError,
parseHeaders = FittHTTPCoreUtils.parseHeaders,

fittHTTPCoreSettle = require('../core/settle.js');

function FittXHRHttpResponse(responseData, respStatus, statusText, respHeaders, config, url) {

	var me = this,
	isIE204 = respStatus === 1223;

	me.data = responseData;
	me.status = isIE204 ? 204 : respStatus;
	me.statusText = isIE204 ? 'No Content' : cstr(statusText);
	me.headers = respHeaders;
	me.config = config;
	me.url = url;
}

function removeXHREvtHandlers(requestXHR) {
	if (requestXHR) {
		try {
			requestXHR[LOAD_EVT] =
			requestXHR[ERR_EVT] =
			requestXHR[TIMEOUT_EVT] = null;
		} catch (e) {}
	}
}

/**
   * Handles dispatching duties for browser usage (client-side)
   *
   * @param {String} url - The resource to request
   * @param {Object} config - The object containing all incoming config parameters
   * @returns {Promise}
   */
function xhr(url, config) {
	return new Promise(function (resolve, reject) {
		var requestData = config && config.data,
		requestHeaders = config && config.headers,
		request = new XMLHttpRequest(),
		/**
                                   * [Client-only]
                                   * Set the `directUrl` flag to true, to make a request without parsing the url and its params.
                                   * Can be used to make a REST API request that accepts duplicate params.
                                   *
                                   * Example: http://fan.core.api.qa.espn.go.com/apis/v2/fans/{SWID}/preferences?id=ABC&id=DEF&id=GHI
                                   *
                                   * NOTE THAT AS of Jan 2018 the above comment is invalid b/c fitt-paramhash was updated
                                   * to support the above use case
                                   *
                                   */
		directUrl = config && config.directUrl,
		oURL = new FittURL(url),
		httpMethod = struc(config && config.method) || 'GET',
		canceler = config && config.canceler,
		cancelerPromise = canceler && canceler.promise,
		confRespType = config && config[RESP_TYPE],
		configTimeout = cnum(config && config.timeout, 100, 100),
		inProgress = false,
		timer;

		oURL.params = new FittParamHash(mix({}, [oURL.params, config && config.params]));

		request.open(httpMethod, directUrl ? url : cstr(oURL), true);

		// Set up cancellation
		if (cancelerPromise) {
			cancelerPromise.then(function (reason) {
				removeXHREvtHandlers(request);
				try {request.abort();} catch (e) {}
				reject(reason);
				request = null;
			});
		}

		// Set the request timeout in MS
		request.timeout = configTimeout;

		// Listen to the progress event
		request[PROGRESS_EVT] = function xhr_onProgress(e) {
			var loaded = e && e.loaded || _get(this, 'response.length') || 0;

			// Update the `inProgress` flag, if we've actually started receiving a response
			if (loaded) {
				inProgress = true;
			}
		};

		// Listen for ready state
		request[LOAD_EVT] = function () {

			var responseHeaders,
			responseData,
			requestStatus,
			requestRespURL,
			response;

			if (!request || request.readyState !== 4) {
				return;
			}

			// Response has been received so kill timer that handles request timeout
			xhr_clearTimeout();

			requestStatus = request.status;
			requestRespURL = cstr(request.responseURL);

			// The request errored out and we didn't get a response, this will be
			// handled by onerror instead
			// With one exception: request that using file: protocol, most browsers
			// will return status as 0 even though it's a successful request
			if (requestStatus === 0 && !(requestRespURL && requestRespURL.indexOf('file:') === 0)) {
				return;
			}

			// Prepare the response
			try {
				responseHeaders = request.getAllResponseHeaders();
				responseHeaders = parseHeaders(responseHeaders);
			} catch (e) {
				responseHeaders = {};
			}
			try {
				responseData = !confRespType || confRespType === 'text' ? request.responseText : request.response;
			} catch (e) {
				responseData = null;
			}

			response = new FittXHRHttpResponse(responseData, requestStatus,
			request.statusText, responseHeaders,
			config, url);

			fittHTTPCoreSettle(resolve, reject, response);

			// Clean up request
			removeXHREvtHandlers(request);
			request = null;
		};

		// Handle low level network errors
		request[ERR_EVT] = function xhr_onError() {
			xhr_clearTimeout();

			// Real errors are hidden from us by the browser
			// onerror should only fire if it's a network error
			reject(createErr('Network Error', url, config));

			// Clean up request
			removeXHREvtHandlers(request);
			request = null;
		};

		// Handle timeout
		request[TIMEOUT_EVT] = function xhr_onTimeout() {
			var timeout = configTimeout;

			if (inProgress && !timer) {
				// Response is being received, defer reject by setting a longer timeout
				timeout = Math.max(MAX_TIMEOUT - configTimeout, 0);
				xhr_setTimeout(timeout);
			} else {
				xhr_endRequest(timeout);
			}

		};

		function xhr_setTimeout(timeout) {
			timer = setTimeout(function xhr_extendedTimeout() {
				xhr_endRequest(timeout);
			}, timeout);
		}

		function xhr_clearTimeout() {
			clearTimeout(timer);
			timer = null;
		}

		function xhr_endRequest(timeout) {
			reject(createErr('timeout of ' + timeout + 'ms exceeded', url, config, 'ECONNABORTED'));

			inProgress = false;

			if (request) {
				// Clean up request
				request = null;
			}
		}

		// Add headers to the request
		if (SET_REQ_HEADER in request) {
			forEach(requestHeaders, function (val, key) {
				if (typeof requestData == TYPE_UNDEF && strlc(key) === 'content-type') {
					// Remove Content-Type if data is undefined
					delete requestHeaders[key];
				} else {
					// Otherwise add header to the request
					try {request[SET_REQ_HEADER](key, val);} catch (e) {}
				}
			});
		}

		// Add withCredentials to request if needed
		if (config && config[WITH_CREDS]) {
			request[WITH_CREDS] = true;
		}

		// Add responseType to request if needed
		if (confRespType) {
			try {
				request[RESP_TYPE] = confRespType;
			} catch (e) {
				if (request[RESP_TYPE] !== 'json') {
					throw e;
				}
			}
		}

		if (typeof requestData == TYPE_UNDEF) {
			requestData = null;
		}

		// Send the request
		request.send(requestData);
	});
}

if (typeof module !== TYPE_UNDEF) {
	module.exports = xhr;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/dispatch/xhr.js
// module id = 611
// module chunks = 0